import { render, staticRenderFns } from "./Relatics.vue?vue&type=template&id=06457ba5"
import script from "./Relatics.vue?vue&type=script&lang=js"
export * from "./Relatics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports